// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {forwardRef, Fragment, useContext, useState} from 'react';
import {useHistory} from 'react-router';
// @ts-ignore
import {Trans} from 'react-i18next';
import cn from 'classnames';
import {perr} from 'hola_pub_util';
import {guess_browser} from 'zuser_agent';
// @ts-ignore
import {App_context} from '../context.js';
import {use_browser} from '../lib/use_browser';
// @ts-ignore
import {GDL} from '../site_load.js';
// @ts-ignore
import {get_env, install_perr, track_download} from '../install_util.js';
import {use_client_hints} from '../client_hints';
import {guess_os_and_version} from '../client_hints_global';
import {use_download} from './use_download';
import {use_install_info} from './use_install_info';
import etask from 'zetask';

const open_link = (link: string, new_tab?: boolean)=>{
    if (new_tab)
        return void window.open(link, '_blank');
    window.location.href = link;
};
export const open_store = (new_tab?: boolean, for_browser?: string)=>{
    const env = get_env();
    const install_opt_ext = {perr_on_step: 'ext_redirect', name: 'ext'};
    const sys = guess_os_and_version();
    if (sys.os=='ios')
        return void open_link(GDL.ios.url, new_tab);

    install_perr('ext_redirect_to_store', {env}, install_opt_ext);
    track_download({name: 'ext', install_opt: install_opt_ext});
    let browser = for_browser;
    if (!for_browser)
    {
        const b = guess_browser();
        if (b.edge)
            b.browser = 'edge';
        if (b.opera)
            b.browser = 'opera';
        browser = b.browser;
    }
    if (browser=='firefox')
        return void open_link(GDL.firefox_signed.url, new_tab);
    open_link((GDL[browser] || GDL.chrome).url, new_tab);
};

export const Install_btn = forwardRef((props: object_of<any>, ref)=>{
    // @ts-ignore
    const {host} = useContext(App_context);
    const {className, btn_ref, src, uninstall_flow, on_click,
        on_agree, keep_btn_text, download_browser, user_country,
        download_vpn, disabled, need_agree, no_redirect, filename} = props;
    const Agree_dialog = props.agree_dialog;
    const experiment_after_dl_flow = false;
    const history = useHistory();
    const [show_agree, toggle_agree] = useState(false);
    use_client_hints();
    let b = use_browser();
    if (['opera', 'chrome', 'edge', 'firefox', 'safari'].indexOf(b)==-1)
        b = 'chrome';
    const {download, download_br, do_agree, get_filename} =
        use_download({need_agree, filename});
    const on_close = ()=>{
        if (uninstall_flow)
            perr({id: 'www_uninstall_hola_close_modal'});
        toggle_agree(false);
    };
    const open_modal = ()=>{
        if (uninstall_flow)
            perr({id: 'www_uninstall_hola_open_modal'});
        toggle_agree(true);
    };
    const on_agree_hdl = ()=>{
        if (on_agree)
            on_agree();
        if (uninstall_flow)
            perr({id: 'www_uninstall_hola_agree_click'});
        if (need_agree)
        {
            on_close();
            do_agree();
        }
    };
    const {app, href, cta, before_redirect} =
        use_install_info({host, download_browser, download_vpn, user_country,
            app_fixed: download_vpn ? 'vpn' : props.app_fixed});
    const text = keep_btn_text ? props.text||`get_hola_its_free` : cta;
    const on_click_hdl = ()=>etask(function*(){
        if (app=='mobile')
            return void open_link(href);
        if (on_click)
            yield on_click(app);
        if (uninstall_flow)
            return void open_modal();
        if (app=='ext')
        {
            if (href)
                return void history.push(href);
            return void open_store();
        }
        if (need_agree)
            open_modal();
        if (app=='vpn'||app=='browser')
        {
            const dl_func = app=='vpn' ? download : download_br;
            const after_dl_flow = href?.startsWith('/after_download?');
            const fn = get_filename({after_dl_flow});
            const after_dl_href = !after_dl_flow ? href : href +
                `${href.includes('?') ? '&' : '?'}filename=${fn}`;
            const {pathname, search, href: w_href} = window.location;
            let install_popup_q_param = pathname+search;
            if (!w_href.includes('app') && experiment_after_dl_flow)
            {
                install_popup_q_param = pathname+search+`${w_href.includes('?')
                    ? '&' : '?'}app=${app}&step=install`;
            }
            return void dl_func({cb: ()=>{
                before_redirect && before_redirect();
                if (experiment_after_dl_flow)
                    return history.push(install_popup_q_param);
                if (!no_redirect)
                    history.push(after_dl_href);
            }, after_dl_flow});
        }
    });
    const btn_cls = cn('btn btn-block btn-action', className);
    return <Fragment>
      {show_agree && <Agree_dialog on_close={on_close}
        on_agree={on_agree_hdl}/>}
      <button className={btn_cls}
        ref={ref||btn_ref} onClick={on_click_hdl} data-clickid={src}
        disabled={disabled}>
        <span><Trans>{text}</Trans></span>
      </button>
    </Fragment>;
});
